import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import "./style.css";

const Button = ({ inverted, children, large, ...props }) => {
  const btnClass = cx("btn", {
    "btn--inverted": inverted,
    "btn--large": large
  });

  return (
    <button className={btnClass} {...props}>
      {children}
    </button>
  );
};

Button.propTypes = {
  inverted: PropTypes.bool,
  children: PropTypes.node.isRequired,
  large: PropTypes.bool
};

export default Button;



// WEBPACK FOOTER //
// ./src/components/Button/index.js